import type {
  ProductsQueryQuery,
  SearchProductsByGtinQuery,
} from "@/api/graphql/generates";
import { SearchProductItem } from "@/components/Search/SearchProducts/SearchProductItem";
import {
  NoResultsParagraph,
  SearchSectionTitleWrapper,
  SearchSectionWrapper,
  SearchSectionsWrapper,
} from "@/components/Search/SearchProducts/style";
import { Divider } from "@getgrover/ui";
import { useTranslations } from "next-intl";

interface SearchSuggestionSectionsProps {
  products:
    | ProductsQueryQuery["searchProducts"]["products"]
    | SearchProductsByGtinQuery["searchProductsByGtin"][];
  query: string;
}

export const SearchProducts = ({
  products,
  query,
}: SearchSuggestionSectionsProps) => {
  const t = useTranslations("search");

  if (!products.length) {
    return null;
  }

  return (
    <SearchSectionsWrapper>
      <SearchSectionWrapper>
        <SearchSectionTitleWrapper>
          <Divider position="left">Products</Divider>
        </SearchSectionTitleWrapper>
        {!products.length ? (
          <NoResultsParagraph>{t("no_results")}</NoResultsParagraph>
        ) : (
          <ul>
            {products.map((item) => {
              if (!item) {
                return null;
              }
              return (
                <SearchProductItem key={item.id} product={item} query={query} />
              );
            })}
          </ul>
        )}
      </SearchSectionWrapper>
    </SearchSectionsWrapper>
  );
};
